import breakpoints, {
  legacyBreakpoints
} from '@carvana/merch-tailwind/breakpoints';
import { useContext, useEffect, useRef } from 'react';
import { useScreenSize } from '~/context/srp/DeviceContext';
import SearchContext from '~/context/srp/SearchContext';

const gridGapCount = 2;
const gridGap = 16;
const minTileWidthThatFitsFullDate = 310;
const totalGap = gridGapCount * gridGap;

const getColumnCount = (screenWidth: number) => {
  if (screenWidth >= breakpoints.lg) return 3;

  return screenWidth >= legacyBreakpoints.m ? 2 : 1;
};

export default function useRefToSetGetItBy(): React.MutableRefObject<HTMLDivElement | null> {
  const mainLayoutRef = useRef<HTMLDivElement>(null);
  const { setShowFullGetItBy, showFullGetItBy } = useContext(SearchContext);
  const { width: screenWidth } = useScreenSize();

  useEffect(() => {
    const layoutWidth = mainLayoutRef.current?.clientWidth ?? 0;
    const columnCount = getColumnCount(screenWidth);
    const tileWidth = (layoutWidth - totalGap) / columnCount;

    setShowFullGetItBy(tileWidth > minTileWidthThatFitsFullDate);
  }, [setShowFullGetItBy, showFullGetItBy, screenWidth]);

  return mainLayoutRef;
}
